import script from "./RadioButtonQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./RadioButtonQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./RadioButtonQuestion.vue?vue&type=style&index=0&id=525ff67b&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525ff67b"]])

export default __exports__